module.exports = __webpack_public_path__ + "static/media/38.5d561d89.JPG";